// Business Entity Types - matches the backend BusinessEntityType enum
export const BUSINESS_ENTITY_TYPES = {
  PUBLIC_CHARITY: 'PublicCharity',
  PRIVATE_FOUNDATION: 'PrivateFoundation',
  S_CORP: 'SCorp',
  C_CORP: 'CCorp',
  LLC: 'LLC',
  LP: 'LP',
  LLP: 'LLP'
} as const;

export type BusinessEntityType = typeof BUSINESS_ENTITY_TYPES[keyof typeof BUSINESS_ENTITY_TYPES];

// Helper functions to get display names
export const getEntityTypeDisplayName = (type: BusinessEntityType): string => {
  const displayNames: Record<BusinessEntityType, string> = {
    [BUSINESS_ENTITY_TYPES.PUBLIC_CHARITY]: 'Public Charity',
    [BUSINESS_ENTITY_TYPES.PRIVATE_FOUNDATION]: 'Private Foundation',
    [BUSINESS_ENTITY_TYPES.S_CORP]: 'S Corporation',
    [BUSINESS_ENTITY_TYPES.C_CORP]: 'C Corporation',
    [BUSINESS_ENTITY_TYPES.LLC]: 'LLC',
    [BUSINESS_ENTITY_TYPES.LP]: 'Limited Partnership',
    [BUSINESS_ENTITY_TYPES.LLP]: 'Limited Liability Partnership'
  };
  return displayNames[type] || type;
};

// Arrays for select options
export const ENTITY_TYPE_OPTIONS = Object.entries(BUSINESS_ENTITY_TYPES).map(([key, value]) => ({
  value,
  label: getEntityTypeDisplayName(value)
}));
